import railsFetch from "../railsFetch";

export interface PreflightParams {
  resource_type: string;
  selection_mode: "explicit" | "all_matching";
  record_ids?: number[];
  excluded_ids?: number[];
  filter_params?: Record<string, unknown>;
}

export interface PreflightResponse {
  totalCount: number;
  counts: Record<string, number>;
}

export async function fetchPreflight(
  bulkOperationsUrl: string,
  params: PreflightParams
): Promise<PreflightResponse | null> {
  try {
    const response = await railsFetch(`${bulkOperationsUrl}/preflight`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ preflight: params }),
    });

    if (response.ok) {
      return await response.json();
    }

    console.error("[preflight] Failed:", response.status);
    return null;
  } catch (error) {
    console.error("[preflight] Error:", error);
    return null;
  }
}
